// Debug logging helpers for both runtimes.
//
// CONTRACTS §9 bans `console.log` in production paths. Use these
// helpers for dev-time tracing; keep `console.error` for genuinely
// unrecoverable errors. Output goes to `console.error` so it still
// shows up in browser devtools / wrangler tail without colliding with
// application log() calls that use console.log at boundaries.
//
// Why two helpers instead of one: the two runtimes have different
// conventions for "is this a dev build?". Sharing a file keeps the
// API discoverable; the functions themselves are independent.

// Server (Workers / Durable Objects). Reads `env.DEBUG === "true"` —
// set in wrangler.toml `[vars]` or via `wrangler secret put DEBUG`.
// Callers pass the DO's `this.env` or the Worker's `env` parameter.
export function serverDebug(
  env: { DEBUG?: string | undefined } | undefined,
  ...args: unknown[]
): void {
  if (env?.DEBUG === "true") console.error("[debug]", ...args);
}

// Client (browser). Gated on Vite's `import.meta.env.DEV`, which Vite
// statically replaces with `true` for `vite dev` and `false` for
// `vite build`. The defensive read lets this file also be imported by
// the server tsc build without blowing up — `import.meta.env` is just
// undefined there and we silently no-op.
export function clientDebug(...args: unknown[]): void {
  const meta = import.meta as { env?: { DEV?: boolean } };
  if (meta.env?.DEV) console.error("[debug]", ...args);
}
